// visitModalTabEnum.ts
// Named tab indices for the owner-facing VisitModalDetailsTabs. Numeric values
// are the historical MUI Tab `value`s — DO NOT renumber. NOTE: these differ from
// OrgVisitModalTab (owner 1=Notes/2=Complaints vs ORG 1=Complaints/2=AiNote), so
// the two modals keep separate enums on purpose.
export enum VisitModalTab {
  Notes = 1, // Notatki wizyty
  Complaints = 2, // Dolegliwości
  Course = 6, // Przebieg wizyty
  Medications = 7, // Leki
  Treatments = 8, // Zabiegi
  Documents = 9, // Dokumenty
  Reminders = 10, // Przypomnienia
  Transcription = 11, // Transkrypcja
}
